export default "__VITE_ASSET__IF9KbmBv__"